const riot = require('riot');

riot.tag2('modal-switcher', '<div class="modal f fclm s-full bg-white rounded-8 pt18 px16 pb24 overflow-hidden m8" ref="modal"> <div class="f fbw fm mb24"> <h2 class="fs16 lh15">プロジェクト移動</h2><i class="icon-close text-label_dark_medium fs24 cursor-pointer" onclick="{close}"></i> </div> <form class="f flex-column w-full" onsubmit="{submit}" onkeydown="{selectionList.onKeyDown}"> <div class="input light_secondary f fm bg-separator_opacity mb12"><i class="icon-search text-label_dark_disabled fs16 mr8"></i> <input class="w-full" type="search" ref="search" oninput="{delaySearch}" placeholder="プロジェクト,#タグ,\'ノート名で検索"><i class="icon-close fs16 cursor-pointer ml8" if="{refs.search.value}" onclick="{onDeleteQuery}"></i> </div> </form> <div class="h-full outline-none border border-separator_opacity rounded-8 overflow-scroll border-top mb8" tabindex="-1" ref="scroll"> <div class="border-bottom" if="{historyItems.length}"> <div class="pt8 pb4 pl12 fs10 lh15 bold">{getSearchMode() === \'notes\' ? ⁗ノート⁗ : ⁗プロジェクト⁗}履歴</div> <div each="{item in historyItems}" data-is="item-selection-list" item="{item}" onclick="{select}" selected-class="bg-pale"> <div data-is="item-switcher_" item="{item}"></div> </div> </div> <div class="pt8 pb4 pl12 fs10 lh15 bold">{getSearchMode() === \'notes\' ? ⁗ノート⁗ : ⁗プロジェクト⁗} </div> <div each="{item, index in items}" data-is="item-selection-list" item="{item}" onclick="{select}" selected-class="bg-pale"> <div data-is="item-switcher_" item="{item}"></div> </div> </div> <div class="f fm fs11 lh15 mb6"><span class="px4 py1 bg-separator_opacity rounded-4 text-label_dark_medium fs10 mr2">#タグ</span>と<span class="px4 py1 bg-separator_opacity rounded-4 text-label_dark_medium fs10 mx2">\'ノート</span>も移動できます。※現在いるプロジェクトのみ</div> <div class="fs11 lh15">{app.shortcut.getCtrlKeyLabel()} + Enter で新しいタブで開く</div> </div>', 'modal-switcher .modal,[data-is="modal-switcher"] .modal{max-width:472px;max-height:80vh;height:494px} modal-switcher input::placeholder,[data-is="modal-switcher"] input::placeholder{font-size:13px} modal-switcher input:focus,[data-is="modal-switcher"] input:focus{outline:none !important}', 'class="f fh s-full bg-overlay_secondary" spat-animation="fade"', function(opts) {

    this.historyItems = [];
    this.historyNotes = [];
    this.historyProjects = [];

    this.switcherHistory = {
      notes: [],
      projects: [],
    };

    this.mixin('selectionList');
    this.on('mount', async () => {

      this.loadLocalStorage();

      this.historyProjects = this.findHistoryProjects();

      this.delaySearch();

      this.historyNotes = await this.fetchHistoryNotes();
      this.update();
    });

    this.submit = (e) => {
      e.preventDefault();
    };

    this.search = async () => {

      let commands = {

        "'": () => {
        },

      };
      let value = this.refs.search.value;
      let commandName = value.slice(0, 1);
      let command = commands[commandName];
      if (!command) {
        command = () => {
          return {
            items: app.store.projectsUsersStore.items.filter(item => !item.data.archived),
            key_or_callback: 'data.project_name',

            image_key: 'data.image',
          };
        };
      }
      else {
        value = value.substr(1);
      }

      if (commandName === "'") {
        const show_project = !app.store.project;
        const parsed = QuerySearch.parseTags(value);
        const {note_refs} = await app.api.child(app.store.workspace.ref.path).child('projects/search_note').get({
          keyword: parsed.text,
          tags: parsed.tags.length ? parsed.tags.join(',') : undefined,
          limit: 100,
          project_id: !show_project ? app.store.project.id : undefined,
        });
        const promises = note_refs.map(async note_path => {
          const note = await app.store.doc(note_path).fetch();
          if (show_project) await note.getProject().fetch();
          return note;
        });
        const notes = await Promise.all(promises);
        this.items = notes.map((note, index) => {
          return {
            isNote: true,
            showProject: show_project,
            index,
            item: note,
            label: note.data.title || 'タイトルがありません',
          };
        });

        this.historyItems = value ? [] : this.historyNotes;
      }
      else {
        let searchArgs = await command();
        searchArgs.value = value;
        this.items = app.utils.fuzzySearchItems(searchArgs).map((item, index) => {
          const getLabel = app.utils.normalizeKeyOrCallback(searchArgs.key_or_callback);
          return {
            isProject: true,
            index,
            item,
            label: getLabel(item),
          };
        });

        this.historyItems = value ? [] : this.historyProjects;
      }
      this.selectionList.selectedIndex = 0;
      this.isSearching = false;
      this.update();
      this.trigger('searched');
      this.refs.scroll.scrollTop = 0;
    };

    this._debouncedSearch = _.debounce(this.search, 150);

    this.delaySearch = () => {
      this.isSearching = true;
      this._debouncedSearch();
    };

    this.switch = async (e) => {
      const {item} = e.item.item;
      let command = {
        "'": () => {

          spat.router.push(`/${item.ref.path}?view=list`);
        },
      }[this.refs.search.value.slice(0, 1)];

      if (command) {
        command();
      }
      else {
        const path = item.getProjectURL();
        spat.router.push(path);
      }
      this.close();
    };

    this.on('selectionList.keydown', (e) => {

      if (!this.refs.search.value && /\s/.test(e.key)) {
        this.refs.search.value = "'";
        e.preventDefault();
        this.delaySearch();
        e.preventSelectionList = true;
        return ;
      }
    });

    this.on('selectionList.keydown.other', (e) => {

      if (document.activeElement !== this.refs.search) {

        this.refs.search.focus();
      }
    });

    this.showHelp = () => {
      spat.modal.alert('プロジェクトの切り替えができます。\nスペース区切りでAND検索ができます。\n最初の文字を \' にするとプロジェクト内のノートの切り替えになります。\n未入力状態でスペースキーを入力すると \' を挿入することもできます。', 'スイッチャーの使い方');
    };

    this.focusInput = () => {
      this.refs.search.focus();
    };

    this.onDeleteQuery = () => {
      this.refs.search.value = '';
      this.refs.search.focus();
      this.delaySearch();
      this.update();
    };

    this.on('selectionList.keydown.enter', () => {
      this.select();
    });

    this.on('selectionList.keydown.commandEnter', () => {
        let item  = [...this.historyItems, ...this.items][this.selectionList.selectedIndex];

        let path = '';
        if (item.isProject) {
          path = item.item.getProjectURL();
        }

        else {
          path = `/${item.item.path}?view=list`;
        }

        if (!path) return ;
        window.open(path, '_blank');
    });

    this.select = () => {
      let _switch = () => {

        let items = [...this.historyItems, ...this.items];
        let select_item = items[this.selectionList.selectedIndex];

        if (select_item) {
          if (select_item.isNote) {
            app.utils.history.addNote(select_item.item.path);
          }
          this.switch({
            item: {
              item: select_item,
            }
          });
        }
      };

      if (this.isSearching) {
        this.one('searched', _switch);
      }
      else {
        _switch();
      }
    };

    this.loadLocalStorage = () => {
      this.switcherHistory = app.utils.history.load(this.switcherHistory);
      this.update();
    };

    this.findHistoryProjects = () => {
      return this.switcherHistory.projects.map(id => {
        let item = app.store.projectsUsersStore.items.find(project => {
          return project.id === id;
        });

        if (!item) {
          return null;
        }
        return {
          isProject: true,
          item,
          label: item.data.project_name,
        };
      }).filter(Boolean);
    };

    this.fetchHistoryNotes = async () => {
      const promises = this.switcherHistory.notes.map(async note_path => {
        try {
          const note = await app.store.doc(note_path).fetch();

          if (!note.data) {
            return null;
          }
          await note.getProject().fetch();
          return note;
        }
        catch {

          return null;
        }
      });
      const notes = await Promise.all(promises);

      return notes.filter(Boolean).map((note, index) => {
        return {
          isNote: true,
          showProject: true,
          index,
          item: note,
          label: note.data.title || 'タイトルがありません',
        };
      });
    };

    this.getSearchMode = () => {

      let modes = {
        "'": 'notes',
      }
      let mode = modes[this.refs.search.value[0]] || 'projects';
      return mode ;
    };

});
riot.tag2('item-switcher_', '<div class="py8 px16 cursor-pointer {\'f fm\' : !item.showProject}"> <div class="inline-block pointer-none mb2" if="{item.showProject}" data-is="atom-project" item="{item.item.getProject()}"></div> <div class="flex-fixed s20 rounded-4 overflow-hidden border mr8" if="{item.isProject}"> <div class="s-full" if="{!item.item.data.project_icon_image}" riot-style="background-color: {getBgColor()}"></div><img class="block s-full object-fit-cover" if="{item.item.data.project_icon_image}" riot-src="{app.utils.getImageUrl(item.item.data.project_icon_image)}"> </div> <div class="f fm fbw w-full"> <div class="f fm fs13 lh15 word-break-all line-clamp-2">{item.label}</div> <div class="pointer-none pl4" if="{item.isNote &amp;&amp; item.item.data.assigned_user_refs.length}" data-is="atom-assign" note="{item.item}"></div> </div> </div>', '', '', function(opts) {
    this.on('mount', async () => {
      this.item = this.opts.item;
      if (this.item.isProject) {
        this.project = await this.item.item.getProject().fetch();
      }
      this.update();
    });

    this.getBgColor = () => {
      return this.project.data.color || `hsl(${app.utils.stringToColorAngle(this.opts.item.item.data.project_name)}, 50%, 70%)`;
    };
});